import { Component, ChangeDetectionStrategy, inject } from '@angular/core'
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { AccountObject } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { BuyersGroupApiService } from 'src/pages/admin/settings/buyers-groups/buyers-groups-item/buyers-groups.service'
import { NonBuyersWarningComponent } from '../../non-buyers-warning/non-buyers-warning.component'

export interface CreateBuyerGroupDialogData {
  selectedCompanies: DeepReadonly<AccountObject>[]
}

@Component({
  selector: 'tc-create-buyer-group-dialog',
  templateUrl: './create-buyer-group-dialog.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    NonBuyersWarningComponent,
  ],
})
export class CreateBuyerGroupDialogComponent {
  private dialogRef = inject<MatDialogRef<CreateBuyerGroupDialogComponent>>(MatDialogRef)
  data = inject<CreateBuyerGroupDialogData>(MAT_DIALOG_DATA)
  private buyersGroupService = inject(BuyersGroupApiService)
  private toaster = inject(ToasterService)

  nameCtrl = new FormControl<string>('', Validators.required)
  saving = false
  buyers: DeepReadonly<AccountObject>[] = []

  cancel() {
    this.dialogRef.close()
  }

  async save() {
    if (this.nameCtrl.invalid) {
      this.toaster.error('Please enter a group name.')
      return
    }

    this.saving = true
    try {
      const buyerIds = this.buyers.map(c => String(c.account))
      await this.buyersGroupService.create({ name: this.nameCtrl.value, buyers: buyerIds })
      this.toaster.success(`Buyer Group "${this.nameCtrl.value}" was created successfully.`)
      this.dialogRef.close(true)
    } catch {
      this.toaster.error(`Unable to create Buyer Group "${this.nameCtrl.value}".`)
    } finally {
      this.saving = false
    }
  }
}
